import { render } from "./JournalCard.vue?vue&type=template&id=62dc3d85&scoped=true"
import script from "./JournalCard.vue?vue&type=script&lang=js"
export * from "./JournalCard.vue?vue&type=script&lang=js"

import "./JournalCard.vue?vue&type=style&index=0&id=62dc3d85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dc3d85"]])

export default __exports__